module.exports = __webpack_public_path__ + "img/list_5_tc.923a302c.png";